import { render } from "./grantDetail.vue?vue&type=template&id=068c0d8a&scoped=true"
import script from "./grantDetail.vue?vue&type=script&lang=js"
export * from "./grantDetail.vue?vue&type=script&lang=js"

import "./grantDetail.vue?vue&type=style&index=0&id=068c0d8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068c0d8a"]])

export default __exports__